import React, { useEffect, useState } from 'react'
import { ListPoliciesRequest } from '@trustero/trustero-api-web/lib/model/policy_pb'
import { usePolicyIds } from '../../../async/policy/usePolicies'
import { usePolicyRequest } from '../../../../pages/Policies/PoliciesIndexPage/PoliciesIndexPage.utils'
import { GridColumnSortPoliciesProps } from './GridColumnSort.constants'
import { getColSortIcon, getNextColSortType } from './GridColumnSort.utils'
import { GridColumnSort } from '.'

export const PoliciesGridColumnSort = ({
  type,
  isActive,
  colName,
  onSort,
}: GridColumnSortPoliciesProps): JSX.Element | null => {
  const findPoliciesRequest: ListPoliciesRequest = usePolicyRequest()
  const { loading } = usePolicyIds(findPoliciesRequest)
  const [showSpinner, setShowSpinner] = useState<boolean>(loading && isActive)
  const currIcon = getColSortIcon(type, isActive)

  useEffect(() => {
    showSpinner && isActive && setShowSpinner(loading)
  }, [showSpinner, isActive, loading])

  const applySorting = (e: React.MouseEvent) => {
    e.preventDefault()
    if (loading) {
      return
    }
    setShowSpinner(true)
    onSort({ colName, type: getNextColSortType(type) })
  }

  return (
    <GridColumnSort {...{ colName, showSpinner, currIcon, applySorting }} />
  )
}
